const basketActionTypes = { SET_BASKET: 'SET_BASKET' };

module.exports = basketActionTypes;
